module.exports = __webpack_public_path__ + "static/img/YesOrNo.260f4b5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/YesOrNo.gif
// module id = EbE6
// module chunks = 0